import React from 'react';
import ReactDOM from 'react-dom/client';
import * as serviceWorker from './serviceWorker';
import './index.css';
import App from './modules/App';
import { isIgnorableResizeObserverError } from './utils/resizeObserverErrors';

if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    if (isIgnorableResizeObserverError(event.message)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
// change to trigger build 14


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
